import { ImageExtractionResponse } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/responses/image-extraction-response';

import { mediaPlatformProvider } from '../../../../../transport/media-platform-provider';
import { Project } from '../../../../../types/entities';

interface ExtractImageByIdParams {
  fileId: string;
  organizationId: string;
  project: Project;
}

export const extractImageById = ({
  fileId,
  organizationId,
  project,
}: ExtractImageByIdParams): Promise<ImageExtractionResponse | Error> => {
  const imageExtractionManager = mediaPlatformProvider.getSDKInstance(
    organizationId,
    project,
  ).imageExtractionManager;

  return imageExtractionManager.extractImageById(fileId);
};
